import React from 'react';
import {
  deleteApprovalKeywordUsingBody,
  useGetFilterRecommend,
  useRecentReadApproval,
} from '@/hooks/apiHooks';
import RecentContent from '@/components/MobileApproval/SearchModal/RecentApproval/RecentContent';
import { useTranslation } from 'react-i18next';
import RoundedButton from '@/components/MobileOrganization/Search/RecentSearch/RoundedButton';
import { useFormContext } from 'react-hook-form';
import useOpenApprovalDocInApp from '@/hooks/approval/useOpenApprovalDocInApp';
import { StyledTitle } from './styles';

const RecentApproval = () => {
  const { data: keywordData, mutate } = useGetFilterRecommend();
  const { data } = useRecentReadApproval();
  const { t } = useTranslation();

  const { setValue } = useFormContext<{ keyword: string }>();

  const onClick = (keyword: string) => {
    setValue('keyword', keyword);
  };

  const onDelete = (keyword: string) => {
    deleteApprovalKeywordUsingBody(keyword).then(() => mutate());
  };

  // 최근 본 문서 응답에는 양식 코드가 없어 단건 조회로 판별 후 채널을 정함.
  // 판별 실패 시엔 기존처럼 포탈 뷰어가 조회 후 결정(뷰어의 레거시 폴백).
  const { openDoc, loadingOverlay } = useOpenApprovalDocInApp();
  const sendPostMessage = (docId: string) => {
    openDoc(docId, { actionType: 'MODAL', fallback: 'viewer' });
  };

  return (
    <div style={{ marginTop: '28px', padding: '0px 8px' }}>
      {keywordData && keywordData.keywords?.length > 0 && (
        <div>
          <StyledTitle>{t('최근 검색어')}</StyledTitle>
          <div
            style={{
              display: 'flex',
              gap: '12px',
              overflowX: 'auto',
              marginTop: '8px',
            }}
          >
            {keywordData.keywords?.map((res, idx) => (
              <RoundedButton
                key={`${res}-${idx}`}
                keyword={res}
                onClick={onClick}
                onDelete={onDelete}
              />
            ))}
          </div>
        </div>
      )}
      {data && data.length > 0 && (
        <div style={{ marginTop: '40px' }}>
          <StyledTitle>{t('최근 본 문서')}</StyledTitle>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              marginTop: '8px',
            }}
          >
            {data.map((res, idx) => (
              <RecentContent
                key={`recent-read-${idx}`}
                {...res}
                sendPostMessage={sendPostMessage}
              />
            ))}
          </div>
        </div>
      )}
      {/* 양식 판별 조회 대기 — 앱 웹뷰에서 결재 문서를 열 때만 뜬다 */}
      {loadingOverlay}
    </div>
  );
};

export default RecentApproval;
